import { Component, inject, ChangeDetectionStrategy, input } from '@angular/core';

import { AssignmentType, AssignmentLoadunitDto } from '../../shared/generated/backend';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import {
  DxBulletModule,
  DxCheckBoxModule,
  DxDateRangeBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxLoadIndicatorModule,
  DxRadioGroupModule,
  DxTemplateModule,
  DxToastModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { DxoSortingModule } from 'devextreme-angular/ui/nested';
import { DxSelectBoxModule, DxButtonModule } from 'devextreme-angular';
import { SharedModule } from '../../shared/shared.module';
import { ContextService } from '../../services/context.service';
import { LoaderComponent } from '../../loader/loader.component';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-assignment-project-loadunits',
  imports: [
    SharedModule,
    DxDataGridModule,
    DxTemplateModule,
    DxBulletModule,
    DxDateRangeBoxModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxRadioGroupModule,
    DxToastModule,
    DxLoadIndicatorModule,
    DxoSortingModule,
    DxDropDownButtonModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    LoaderComponent,
  ],
  templateUrl: './assignment-project-loadunits.component.html',
  styleUrls: ['./assignment-project-loadunits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentProjectLoadunitsComponent {
  readonly assignmentId = input.required<number>();

  readonly type = input.required<AssignmentType>();

  readonly loadunits = input<AssignmentLoadunitDto[]>();

  /** True while the parent context view is still loading the data. */
  readonly isLoading = input<boolean>(false);

  private contextService = inject(ContextService);

  handleCellClick(event: RowDblClickEvent) {
    this.contextService.openContextView(`project/${event.data.TrapoProjektNr}`);
  }

  // Intentionally no API call here; data is provided by the parent context view.
}
